import Auth from '@aws-amplify/auth'
import { AuthState } from '@aws-amplify/ui-components'
import { Formik } from 'formik'
import React from 'react'
import * as Yup from 'yup'

import { useNotification } from 'src/modules/notification'
import {
  Button,
  Form,
  FormikPasswordField,
  FormikTextField,
  FIELD_REQUIRED,
} from 'src/modules/ui'

import FormActions from './FormActions'
import FormHeader from './FormHeader'
import FormLinks from './FormLinks'
import FormLink from './FormLink'

export const ForgotPasswordSetNewForm = ({
  handleSubmit,
  isReset,
  isSubmitting,
  onClickBackToSignin,
  onClickResendCode,
}) => (
  <div>
    <FormHeader
      title={isReset ? 'Password Reset Required' : 'Forgotten Password'}
      subtitle="Enter the verification code we just sent to your email address and your new password"
    />
    <Form>
      <FormikTextField
        fullWidth
        label="Verification Code"
        name="code"
        margin="normal"
      />
      <FormikPasswordField
        fullWidth
        label="Password"
        name="password"
        margin="normal"
      />
      <FormLinks>
        <FormLink onClick={onClickBackToSignin}>Back To Signin</FormLink>
        <FormLink onClick={onClickResendCode}>Resend Code</FormLink>
      </FormLinks>
      <FormActions>
        <Button
          onClick={handleSubmit}
          color="primary"
          isLoading={isSubmitting}
          size="large"
          type="submit"
        >
          Set New Password
        </Button>
      </FormActions>
    </Form>
  </div>
)

const ForgotPasswordSetNew = ({ onStateChange, username, ...props }) => {
  const { showError, showSuccess } = useNotification()

  const validationSchema = Yup.object().shape({
    code: Yup.string().required(FIELD_REQUIRED),
    password: Yup.string().required(FIELD_REQUIRED),
  })
  const initialValues = { code: '', password: '' }

  const handleSubmit = async ({ code, password }, { setFieldError }) => {
    try {
      await Auth.forgotPasswordSubmit(username, code, password)
      showSuccess('New password set successfully')
      onStateChange(AuthState.SignIn)
    } catch (err) {
      if (err.code === 'CodeMismatchException') {
        setFieldError('code', 'Bad code supplied')
      } else if (err.code === 'InvalidPasswordException') {
        setFieldError('password', err.message)
      } else {
        showError(err.message)
      }
    }
  }
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      {formik => <ForgotPasswordSetNewForm {...formik} {...props} />}
    </Formik>
  )
}

export default ForgotPasswordSetNew
